// Start here's 1 write (docs/data-model.md 10.6.2): the member's own answers on 1 screen, as
// themselves, through row level security, and whether to mark it done. The database keeps only the
// screen's own keys, works out each score, whether a quick check or a house was right and the second
// channel's label, keeps a call once made, holds the gate (in order, done only when answered, never
// undone) and stamps the time. What comes back is the row as the database has it.
// Never called while staff view as a member (the screens check first; the database refuses anyway).
import { supabase, must } from '../../../lib/supabase.js'
import { STEP_PROGRESS_ANSWERS } from '../../../product/columns.js'

// answers: only the keys this save changes (the database merges them over what's there);
// done: true to mark the screen done, which the database stamps with its own time
export async function saveScreen(personId, stepId, answers, { done = false, nowIso = null } = {}) {
  const rows = await supabase.from('step_progress')
    .upsert({ person_id: personId, step_id: stepId, answers: answers || {}, done_at: done ? (nowIso || new Date().toISOString()) : null },
      { onConflict: 'person_id,step_id' })
    .select(STEP_PROGRESS_ANSWERS)
    .then(must)
  return rows?.[0] || null
}
